module.exports = __webpack_public_path__ + "static/media/wall-icon.837d9ef8.svg";